import { ErrorType } from 'playback-web-player';

const startupErrors = [
    ErrorType.MANIFEST_REQUEST_FAILED_DURING_LOAD,
    ErrorType.SEGMENT_REQUEST_FAILED_DURING_LOAD,
];

const midStreamErrors = [
    ErrorType.MANIFEST_REQUEST_FAILED_DURING_PLAYBACK,
    ErrorType.SEGMENT_REQUEST_FAILED_DURING_PLAYBACK,
];

const unknownErrors = [
    ErrorType.UNKNOWN_SOLUTION_ERROR,
];

const isErrorType = (errorTypes, { type }) => errorTypes.includes(type);

const isStartupError    = isErrorType.bind(null, startupErrors);
const isMidStreamError  = isErrorType.bind(null, midStreamErrors);
const isUnknownError    = isErrorType.bind(null, unknownErrors);

export {
    isStartupError,
    isMidStreamError,
    isUnknownError,
};
